var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49993 8.49998L1.58327 5.58331C1.25827 5.25831 0.741601 5.25831 0.416602 5.58331C0.0916016 5.90831 0.0916016 6.42497 0.416602 6.74997L3.90827 10.2416C4.23327 10.5666 4.75827 10.5666 5.08327 10.2416L13.9166 1.41664C14.2416 1.09164 14.2416 0.574975 13.9166 0.249976C13.5916 -0.0750244 13.0749 -0.0750244 12.7499 0.249976L4.49993 8.49998Z",
    fill: "#50BD89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.3a522182.svg";
export { ForwardRef as ReactComponent };